import React from "react";
import styled from "styled-components";
import { Table } from "@workboard/wobo-ui";
import Empty from "../../../Empty";
import Header from "./Header";
import Template from "./Template";

const TableBreakdown = ({
  className,
  data,
  pageData,
  rowsPerPageValues,
  isLoading,
  // eslint-disable-next-line
  onChange = () => {},
  key,
}) => (
  <Table
    className={className}
    data={data.teamStats ? data.teamStats : []}
    isLoading={isLoading}
    header={Header}
    empty={Empty}
    orderBy={pageData.columnName}
    order={pageData.order}
    row={Template}
    rowsPerPageValues={rowsPerPageValues}
    rowsPerPage={pageData.rowsPerPage}
    totalDataCount={data.totalTeamCount ? data.totalTeamCount : undefined}
    onChange={onChange}
    aria-label="Select a table column heading to sort the data"
    data-testid="table"
    key={key}
  />
);

export default styled(TableBreakdown)``;
